export default __webpack_public_path__ + "audio-distinguish6f6317.png";